import { InvoiceData } from "./interface";

export const getProductBasedInvoice = (
  productName: string,
  invoiceData: InvoiceData[]
): InvoiceData[] => {
  const filteredInvoices = invoiceData.filter((invoice) =>
    invoice.items.some((item) => item.productName === productName)
  );
  return filteredInvoices ?? [];
};
